import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import Gradient, { GRADIENT_POSITION_BOTTOM } from '@/components/app/Gradient';
import PlayerBarSmall from '@/components/component-library/PlayerBar/PlayerBarSmall';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import useMusicPlayerSeekerBar from '@/hooks/audio/useMusicPlayerSeekerBar';
import { classes } from '@/helpers/styling';
import useAudioReduxControls from '@/hooks/audio/useAudioReduxControls';
import {
  selectAudioPaused, selectCurrentEpisode, selectPlayPauseIsAvailable
} from '@/state/selectors/audio';

const selector = (state) => ({
  paused: selectAudioPaused(state),
  disablePlayPause: !selectPlayPauseIsAvailable(state),
  currentlyPlayingEpisode: selectCurrentEpisode(state)
});

const MiniPlayer = ({
  isOpen,
  onClickPlayer,
  isFiltered
}) => {
  const { currentPercentage } = useMusicPlayerSeekerBar();
  const { handlePlayOrPause: onPlayOrPause } = useAudioReduxControls();
  const {
    paused,
    disablePlayPause,
    currentlyPlayingEpisode
  } = useSelector(selector, shallowEqual);

  const handlePlayOrPause = useCallback((e) => {
    e.stopPropagation();

    onPlayOrPause();
  }, [onPlayOrPause]);

  const {
    id: episodeId,
    title: episodeTitle,
    episode_number: episodeNumber,
    show
  } = currentlyPlayingEpisode || {};
  const {
    title: showTitle,
    assets,
    id: showId
  } = show || {};

  return (
    <div
      className={ classes(
        styles.mobilePlayerBarWrapper,
        {
          [styles.isHidden]: !isOpen || isFiltered,
          '--is-filtered': isFiltered
        }
      ) }
      data-nosnippet=''
      onClick={ onClickPlayer }
    >
      <Gradient
        breadth='250%'
        directionReverse
        gradientBreadth='100%'
        position={ GRADIENT_POSITION_BOTTOM }
      />
      <LayoutWrapperHorizontal className={ styles.mobilePlayerBar }>
        <PlayerBarSmall
          assets={ assets }
          disablePlayPause={ disablePlayPause }
          episodeId={ episodeId }
          episodeNumber={ Number(episodeNumber) }
          episodeTitle={ episodeTitle }
          onClickPlayPause={ handlePlayOrPause }
          paused={ paused }
          progressPercentage={ currentPercentage }
          showId={ showId }
          showTitle={ showTitle }
        />
      </LayoutWrapperHorizontal>
    </div>
  );
};

MiniPlayer.propTypes = {
  isOpen: PropTypes.bool,
  isFiltered: PropTypes.bool,
  onClickPlayer: PropTypes.func.isRequired
};

MiniPlayer.defaultProps = {
  isOpen: false,
  isFiltered: false
};

export default MiniPlayer;